import(/* webpackMode: "eager" */ "/home/u269702617/domains/symbiosis-paysage.fr/hbuilds/source/repository/node_modules/next/dist/client/app-dir/link.js");
